<template>
  <div :style="{height: '100%'}">
    <stub />
    <portfolio-projects v-if="mode==='projects'" />
    <list-view v-if="mode==='list'" />
<!--    <kanban v-if="mode==='board'" />-->
    <workload v-if="mode==='workload'" />
    <export v-if="mode==='export'" />
    <resources v-if="mode==='resources'" />
    <gantt-view
      v-if="mode==='gantt'"
      @ready="initGanttInstance"
    />
    <portfolio-dashboard v-if="mode==='dashboard'" />

    <confirm-popup
      :show="portfolioDeleteObj"
      :popup-width="450"
      :close-icon="true"
      :title="locale('project_list_delete_multiview')"
      :text="deleteConfirmMessage"
      :confirm-message-class="'multiline'"
      :cancel-button="{
        title: locale('common_cancel'),
        type: 'secondary'
      }"
      :ok-button="{
        title: locale('common_delete'),
        type: 'destructive'
      }"
      @onClickCancel="closeModal"
      @onClickOk="deletePortfolio"
    />

    <router-view />
  </div>
</template>

<script>
import routerGuard from '../../router/guards';
import routerHelper from '../../helpers/router';
import projectsModel from '$$projectModel';
import multiViewsProjects from '$$multiviewModel';
// import Kanban from '../kanban/Kanban.vue';
import Export from '../export/Export.vue';
import Workload from './workloadPage/workload.vue';
import ProjectResources from '../resources/main.vue';
import listView from '../listView/listView.vue';
import portfolioProjects from '../portfolioProjects/portfolioProjects.vue';
import PortfolioDashboard from '../portfolioDashboard/PortfolioDashboard.vue';
import stub from '../stubs/stubPage.vue';
import ganttView from '../ganttView/ganttView.vue';
import ganttViewConstructor from '../ganttView/init';
import app from '$$app';
import globalToast from '$$vueCmp/toast';
import ConfirmPopup from '../common/VueComponents/popups/coreConfirmPopup/coreConfirmPopup.vue';

export default {
  name: 'MultiviewPage',
  components: {
    // kanban: Kanban,
    export: Export,
    resources: ProjectResources,
    workload: Workload,
    'list-view': listView,
    'gantt-view': ganttView,
    portfolioProjects,
    PortfolioDashboard,
    ConfirmPopup,
    stub,
  },
  beforeRouteUpdate: routerGuard.multiViewGuard,
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'project') {
      projectsModel.activeGanttId = projectsModel.getFirstId();
    }

    const isEditingTitle = this.$store.getters['headerView/isEditingTitle'];
    const settingsOpened = this.$store.getters['headerView/isShowSettingsPopup'];
    const filterOpened = this.$store.getters['headerView/isShowFilter'];

    isEditingTitle && this.$store.dispatch('headerView/saveHeadTitle');
    settingsOpened && app.trigger('closeWindowWithAnimation');
    filterOpened && app.trigger('hideFilterPopup');

    multiViewsProjects.clearActiveMultiView();

    next();
  },
  props: {
    mode: {
      type: String,
      default: 'gantt',
    },
  },
  data() {
    return {
      locale: __,
      portfolioDeleteObj: null,
      deleteConfirmMessage: __('settings_msg_delete_multiview_confirm_text'),
      listeners: [],
      multiviewListeners: [],
    };
  },

  watch: {
    mode(mode) {
      projectsModel.setActiveProjectMode(mode);
    },
  },
  mounted() {
    projectsModel.setActiveProjectMode(this.mode); // init render

    this.listeners.push(app.on('portfolio:deleteConfirm', ({ id, name }) => {
      this.portfolioDeleteObj = { id, name };
    }));

    this.multiviewListeners.push(multiViewsProjects.data.attachEvent('onStoreUpdated', (id, data, method) => {
      if (method === 'delete' && id === +this.$route.params.multiviewID) {
        routerHelper.pushRoute('/portfolio');

        if (!multiViewsProjects.getAllMultiviews().length) {
          setTimeout(() => globalToast.success(this.locale('portfolio_page_portfolio_deleted', { name: data.name })), 100);
        }

        this.portfolioDeleteObj = null;
      }
    }));

    app.trigger('gantt:progress:hide');
  },
  beforeUnmount() {
    this.listeners.forEach(id => app.off(id));
    this.multiviewListeners.forEach(listener => multiViewsProjects.data.detachEvent(listener));
    this.listeners = [];
    this.multiviewListeners = [];
  },
  methods: {
    closeModal() {
      this.portfolioDeleteObj = null;
    },
    deletePortfolio() {
      let showDeleteToast = false;

      if (multiViewsProjects.getAllMultiviews().length === 1) {
        showDeleteToast = true;
      }

      multiViewsProjects.removeMultiview(this.portfolioDeleteObj.id);
      const name = this.portfolioDeleteObj.name;
    },
    initGanttInstance() {
      ganttViewConstructor.initGanttInstanceMultiView(+this.$route.params.multiviewID);
    },
  },
};
</script>

<style scoped>

</style>
